<template>
    <div v-if="copyNode">
        <label for="section-title">Section Title:</label>
        <b-form-input
            id="section-title"
            v-model="copyNode.title"
            :state="nameState"
            aria-describedby="input-live-help input-live-feedback"
            placeholder="Enter your name"
            trim/>
        <b-form-invalid-feedback id="input-live-feedback">
            Enter at least 3 letters
        </b-form-invalid-feedback>

        <b-button size="sm" 
                  class="m-2 float-right"
                  variant="outline-primary"
                  @click="onSubmit"
                  :disabled="!nameState">Submit</b-button>
        <b-button size="sm" 
                  class="m-2 float-right"
                  variant="outline-danger"
                  @click="$emit('onCancel')">Cancel</b-button>
    </div>
</template>

<script>
export default {
    name : 'TreeMenuSection',
    props : ['node'],
    data() { return { copyNode : null } },
    computed : {
        nameState() {
            return this.copyNode && this.copyNode.title && this.copyNode.title.length > 2 ? true : false
        }
    },
    watch : {
        node : {
            deep: true,
            handler(newValue) {
                if(newValue.method === "addChild") {
                    this.copyNode = { title : "" , items:[] }
                } else {
                    this.copyNode = this.$deepCopy(newValue.node);
                }
            }
        }
    },
    created() { 
        if(this.node.method === "addChild") {
            this.copyNode = { title : "" , items:[] }
        } else {
            this.copyNode = this.$deepCopy(this.node.node); 
        }
    },
    destroyed() { },
    methods: { 
        onSubmit() {
            this.$emit("onSubmit", this.copyNode)
        }, 
    },
}
</script>

<style scoped lang="scss">

</style>